export class OfferClient {
    constructor(
        public ClientType?: String,
        public Firstname?: String,
        public Lastname?: String,
        public CompanyName?: String,
        public JMBG?: String,
        public Mobile?: String,
        public Email?: String,
        public Address?: String,
        public Settlement?: String,
        public PostalCode?: String,
        public DeliveryAddress?: String,
        public DeliverySettlement?: String,
        public DeliveryPostalCode?: String,
        public PhonebookID?: Number,
        public TaxID?: String,
        public CompanyID?: String,
        public ID?: Number) { }
}